export const homepageUrl = '/';

